module.exports = __webpack_public_path__ + "static/emmett-shear-fbd79dddc43a9c660a8a73c751c009f9.jpg";